import { InputHTMLAttributes } from 'react';
import { FieldValues } from 'react-hook-form';
import { t } from 'utils/getTranslations';
import { isValidNumber } from '../rhf-validators/validators';
import TextInput, { TextInputProps } from './TextInput';

interface NumberInputProps<T extends FieldValues> extends TextInputProps<T> {
    inputProps?: Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;
}

const NumberInput = <T extends FieldValues>({ inputProps, validate, ...restProps }: NumberInputProps<T>) => {
    const transformEventBeforeChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ): React.ChangeEvent<HTMLInputElement> => {
        if (!e?.target.value || isNaN(Number(e?.target.value))) {
            return e;
        }
        if (inputProps?.min !== undefined && Number(e.target.value) < Number(inputProps.min)) {
            e.target.value = String(inputProps.min);
        }
        if (inputProps?.max !== undefined && Number(e.target.value) > Number(inputProps.max)) {
            e.target.value = String(inputProps.max);
        }
        return e;
    };

    return (
        <TextInput
            pattern="^[0-9]*$"
            {...restProps}
            validate={{
                ...(typeof validate === 'function' ? { custom: validate } : validate),
                mustBeNumber: isValidNumber(t('validation.must-be-number')),
            }}
            inputProps={{ type: 'number', ...inputProps }}
            transformEventBeforeChange={transformEventBeforeChange}
        />
    );
};

export default NumberInput;
